import { Container } from '@/components/container';
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from '@/partials/toolbar';
import { useLayout } from '@/providers';
import { AdvertiseListings } from './AdvertiseListings';
import { usePermissions } from '@/hooks/usePermissions';
import { useNavigate } from 'react-router-dom';

const AdvertiseManagement = () => {
  const { currentLayout } = useLayout();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const handleCreateNavigate = () => navigate('/advertise/create');

  return (
    <section role="region" aria-label="Advertisement Management">
      {currentLayout?.name === 'demo1-layout' && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="advertise-management-heading" />
              <ToolbarDescription>
                You can manage your advertisements here.
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              {hasPermission('advertisement_management_create') && (
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={handleCreateNavigate}
                  aria-label="Add new advertisement"
                >
                  Add New Advertisement
                </button>
              )}
            </ToolbarActions>
          </Toolbar>
        </Container>
      )}
      <Container>
        <AdvertiseListings />
      </Container>
    </section>
  );
};

export { AdvertiseManagement };
